module.exports = __webpack_public_path__ + "img/confirm.5bf558d6.png";